import { FAVOURITE } from '@/constants'
import { BookmarkIcon } from '@/components/icons/bookmark-icon/bookmark-icon'
import { Image } from '@/components/v2/atoms/image/image'
import Link from 'next/link'
import s from './special-card.module.css'
import cx from 'classnames'

type Props = {
  category: string
  date: string
  header: string
  imageUrl: string
  description: string
  path: string
  type: 'featureCard'
  itemId: number
  theme: 'light' | 'dark'
  headingLevel?: 'h2' | 'h3' | 'h4'
}

export const SpecialCard = ({
  category,
  date,
  header,
  imageUrl,
  description,
  path,
  type,
  itemId,
  theme,
  headingLevel: HeadingTag = 'h3',
}: Props) => {
  const favType = FAVOURITE.ARTICLE
  const isDark = theme === 'dark'

  return (
    <div
      className={cx(s.container, {
        [s.dark]: isDark,
      })}
    >
      <div className={s.topSection}>
        <div>
          <span className={s.category}>{category}, </span>
          {date}
        </div>
        <div className={s.bookmark}>
          <BookmarkIcon itemId={itemId} type={favType} />
        </div>
      </div>
      <HeadingTag className={s.header}>{header}</HeadingTag>
      <Image alt="article image" src={imageUrl} width={163} height={203} />
      <p className={s.description}>{description}</p>
      <Link className={s.button} href={path}>
        Read more
      </Link>
    </div>
  )
}
